export default [
    {
        path: "monthly-invoicing",
        name: "MonthlyInvoicing",
        meta:{
            permissionPath: 'stores.debts.monthly_invoice',
        },
        component: () =>
            import(
                /* webpackChunkName: "monthlyInvoicing" */ "@/views/loyaltyPanel/branchDebt/tabs/MonthlyInvoicing.vue"
            )
    },
    {
        path: "monthly-points",
        name: "MonthlyPoints",
        component: () =>
            import(
                /* webpackChunkName: "monthlyInvoicing" */ "@/views/loyaltyPanel/branchDebt/tabs/MonthlyPoints.vue"
            )
    },
    {
        path: "redemption-invoice",
        name: "RedemptionInvoice",
        meta:{
            permissionPath: 'stores.debts.redemption_invoice',
        },
        component: () =>
            import(
                /* webpackChunkName: "redemptionInvoice" */ "@/views/loyaltyPanel/branchDebt/tabs/RedemptionInvoice.vue"
            )
    },
    {
        path: "sms-metrics",
        name: "SMSMetrics",
        component: () =>
            import(
                /* webpackChunkName: "redemptionInvoice" */ "@/views/loyaltyPanel/branchDebt/tabs/SMSMetrics.vue"
            )
    },
    {
        path: "viber-metrics",
        name: "ViberMetrics",
        component: () =>
            import(
                /* webpackChunkName: "redemptionInvoice" */ "@/views/loyaltyPanel/branchDebt/tabs/ViberMetrics.vue"
            )
    }
];
